export const regexpAlphanumeric = /^[a-zA-Z0-9ａ-ｚＡ-Ｚ０-９]+$/;

export const regexpNumeric = /^[0-9０-９]+$/;

export const regexpPhone = /^[0-9\-０-９ー]+$/;

export const regexpEmail = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9_.-]+$/;

/*
 * \u30A0-\u30FF は全角カタカナのUnicode範囲を表します。
 * \uFF65-\uFF9F は半角カタカナのUnicode範囲を表します。
 * \s は空白文字（スペース、タブ、改行など）を表します。
 */
export const regexpKatakana = /^[\u30A0-\u30FF\uFF65-\uFF9F\s]+$/;
